import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICity } from "src/models/General/City.models";

interface CityState {
  cities: ICity[];
  cityToEdit: ICity | null;
}

const initialState: CityState = {
  cities: [],
  cityToEdit: null,
};

const citySlice = createSlice({
  name: "City",
  initialState,
  reducers: {
    setCityList: (state, action: PayloadAction<ICity[]>) => {
      state.cities = action.payload;
    },
    concatListCity: (state: CityState, action: PayloadAction<ICity[]>) => {
      state.cities = [...state.cities.concat(action.payload)];
    },
    setCityToEdit: (state, action: PayloadAction<ICity | null>) => {
      state.cityToEdit = action.payload;
    },
    addCity: (state, action: PayloadAction<ICity>) => {
      state.cities.push(action.payload);
    },
    updateCity: (state, action: PayloadAction<ICity>) => {
      let itemIndex = state.cities.findIndex(
        item => item.cityId === action.payload.cityId
      );
      if (itemIndex !== -1) state.cities[itemIndex] = action.payload;
    },
    deleteCity: (state, action: PayloadAction<number>) => {
      const newArray = state.cities.filter(
        item => item.cityId !== action.payload
      );
      state.cities = newArray;
    },
  },
});

export const {
  setCityList,
  concatListCity,
  setCityToEdit,
  addCity,
  updateCity,
  deleteCity,
} = citySlice.actions;

export default citySlice.reducer;
